import { render, staticRenderFns } from "./CoupassCsAssistant.vue?vue&type=template&id=1bdc2665&scoped=true"
import script from "./CoupassCsAssistant.vue?vue&type=script&lang=js"
export * from "./CoupassCsAssistant.vue?vue&type=script&lang=js"
import style0 from "./CoupassCsAssistant.vue?vue&type=style&index=0&id=1bdc2665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdc2665",
  null
  
)

export default component.exports